import { BCMSRecord, BCMSStateManagerCRUD, useBCMSContext, useStateManager, useWorkflow } from "@bcm-dev/bcms-vite";
import { CenterContentContainer, ContentHeaderView, FormContainer, FormRowView, PageContainer, PageContentView } from "components/shared";
import { FormButtonRow } from "components/shared/containers/FormContainer";
import { UIButton, UITextInput } from "components/ui";
import Classes from "model";
import React from "react";
import "./styles.css"
import { ImageAsset } from "res";

/**
 * @function SoftTokensActivateTokenActivationPage
 * @return {React.Component}
 * @exported true
 * @description The main component for SoftTokensActivateTokenActivationPage.
 */
export default function SoftTokensActivateTokenActivationPage(props) { 
    const { nextStep } = useWorkflow() ?? {};
    const globalController = useBCMSContext();
    BCMSRecord.globalControllerFor(Classes, globalController);
    const data = { ...getDefaultData(), ...props.data ?? {} };
    const ui = { ...getDefaultUI(), ...props.ui ?? {} };

    const controller = (state, setState) => ({
        data: state.data,
        ui: state.ui,
        onChange: prop => value => {
            BCMSStateManagerCRUD.init(state)
            .update([ "data", prop], { value: value })
            .submit(setState);
        },
        gotToNextStep: () => nextStep()
    });

    return (
        <PageContainer className="soft-tokens-activate-token-activation-page" state={ { data, ui } } controller={ controller }>
            <PageContent/>
        </PageContainer>
    );
}

export const getDefaultData = () => ({
    activationSignature: { value: "" }
});

export const getDefaultUI = () => ({
    // no ui changes for now.
});

function PageContent() {
    const { gotToNextStep, onChange, data } = useStateManager();

    return (
        <PageContentView>
            <CenterContentContainer>
                <ContentHeaderView text="Activate Token" />
                <p className="subtitle text-section">Instructions</p>

                <div className="instructions-container">
                    <p>1. Follow the instructions in the DIGIPASS app to scan the second Cronto image.</p>
                    <p>2. Scan the Cronto image presented below.</p>
                    <p>3. Follow the instructions on your mobile device to complete the registration. The app will return an Activation Signature. Enter the signature below.</p>
                </div>

                <p className="text-section">Scan the image presented below, and press "Activate". Return to your mobile device and follow the instructions in the DIGIPASS app.</p>

                <div className="flex-container flex-horizontal qr-code-container">
                    <div className="flex-container flex-vertical align-center">
                        <ImageAsset id="DigiPassQRCodeIcon" className="qr-code-image" data-point="Soft_Tokens_Activate_Token_Activation_Page_Digi_Pass_QR_Code_Icon"  />
                    </div>
                </div>
                <p className="text-section activation-digi-pass-text">Please enter the Activation Signature provided by the DIGIPASS pass.</p>

                <FormContainer className="small-form-width">
                    <FormRowView className="set-width" text="* Activation Signature">
                        <UITextInput value={ data.activationSignature.value }
                        dataPoint="Soft_Tokens_Activate_Token_Activation_Page_Signature_Input" onChange={ onChange("activationSignature") } />
                    </FormRowView>
                    <FormButtonRow>
                        <UIButton className="secondary-button" text="Cancel" dataPoint="Soft_Tokens_Activate_Token_Activation_Page_Cancel_Button" />
                        <UIButton className="primary-button" text="Activate" dataPoint="Soft_Tokens_Activate_Token_Activation_Page_Activate_Button" onClick={ gotToNextStep } />
                    </FormButtonRow>
                </FormContainer>
            </CenterContentContainer>
        </PageContentView>
    );
}
